import { AxiosResponse } from "axios";
import LoginService from "pages/login/login.service";
import { axiosRequest } from "../../../axios/axios.config";
import { FlowConsignadoImpressaoDTO } from "./consignado-impressao.model";

const ConsignadoImpressaoService = () => {
  const path = "/flow/consignado/impressao";
  const loginService = LoginService();

  return {
    impressao(
      uuidConsignado: string,
      chaveAcesso?: string
    ): Promise<AxiosResponse<FlowConsignadoImpressaoDTO>> {
      const params = chaveAcesso ? { chaveAcesso } : undefined;
      return axiosRequest.get(`${path}/${uuidConsignado}`, {
        headers: loginService.getHeaders(),
        params,
      });
    },
  };
};

export default ConsignadoImpressaoService;
